import HomePage from './page/index';

export const HomeRouter = [
  {
    path: '/home',
    exact: true,
    component: HomePage,
  },
];
